import TextLayout from "~/components/common/TextLayout";
import htmlContent from "~/data/legal-document/billing.html?raw";

export default function BillingTermsPage() {
  return <TextLayout title="Billing Terms" htmlContent={htmlContent} />;
}
